import { render, staticRenderFns } from "./ProjectTaskTemplateNew.vue?vue&type=template&id=ed17f278&"
import script from "./ProjectTaskTemplateNew.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskTemplateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports